<div class="input d-flex align-center justify-flex-end">
  <input
    type="text"
    class="input-field"
    [placeholder]="placeholder"
    [(ngModel)]="value"
    (ngModelChange)="value = $event; onChange($event)"
  />
</div>
